import { ActionType } from "../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../react-core/Flux/Dispatcher";
import { NetworkInstructionStoreStatic } from "./NetworkInstructionStoreStatic";
import { NetworkWizardStoreStatic } from "./NetworkWizardStoreStatic";
import { NetworkStoreStatic } from "./NetworkStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const NetworkInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const NetworkInstructionStore: NetworkInstructionStoreStatic = new NetworkInstructionStoreStatic();
export const NetworkWizardDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const NetworkWizardStore: NetworkWizardStoreStatic = new NetworkWizardStoreStatic();
export const NetworkDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const NetworkStore: NetworkStoreStatic = new NetworkStoreStatic();
